import {
  HttpContextToken,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';

/**
 * Set this context token to true on a request to skip the global spinner.
 */
export const SKIP_GLOBAL_SPINNER = new HttpContextToken<boolean>(() => false);

let activeRequestCount = 0;

/**
 * loadingInterceptor
 *
 * Shows a global spinner while one or more HTTP requests are in flight.
 * Uses a request counter to avoid premature hide with concurrent requests.
 */
export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next,
) => {
  const spinner = inject(SpinnerService);

  if (req.context.get(SKIP_GLOBAL_SPINNER)) {
    return next(req);
  }

  if (activeRequestCount === 0) {
    spinner.show();
  }
  activeRequestCount++;

  return next(req).pipe(
    finalize(() => {
      activeRequestCount = Math.max(0, activeRequestCount - 1);
      if (activeRequestCount === 0) {
        spinner.hide();
      }
    }),
  );
};
